import SingleSelection from 'src/components/Selection/SingleSelection';
import { useTranslation } from 'src/hooks';
import { translatePrefix } from '../../..';
import { EnumReferralCodeStatus } from '@wallet-manager/pfh-pmp-node-def-types/dist/src/DbModel/Master';

interface IProps {
  value: any;
  onChange: (e: any) => void;
  onClear: () => void;
}

const ReferralCodeStatusSingleSelection = ({ value, onChange, onClear }: IProps) => {
  const { tc, t, translate } = useTranslation(translatePrefix);

  const EnumReferralCodeStatusFiltered = Object.fromEntries(
    Object.entries(EnumReferralCodeStatus)
      .filter(([key]) => key !== 'Deleted')
      .reverse() // For display order
  );

  return (
    <SingleSelection
      label={tc('phSelection', { fieldName: t('referralCodeStatus') })}
      value={value || ''}
      onChange={onChange}
      clearSelect={onClear}
      enumData={EnumReferralCodeStatusFiltered}
      isNoSorting
      nameFn={(item) => translate(`EnumReferralCodeStatus.${item}`)}
    />
  );
};

export default ReferralCodeStatusSingleSelection;
